import script from "./AdminTopbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminTopbar.vue?vue&type=script&setup=true&lang=ts"

import "./AdminTopbar.vue?vue&type=style&index=0&id=2b0a8c2a&lang=scss"

const __exports__ = script;

export default __exports__